import { render, staticRenderFns } from "./SpcmSessionEdit.vue?vue&type=template&id=854c286c"
import script from "./SpcmSessionEdit.vue?vue&type=script&lang=js"
export * from "./SpcmSessionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports